import {Emitter} from "./emitter";
import {BundleQuantitySelector} from "./bundle_quantity_selector";
import {rechargeControl} from "./recharge_bundle_control";
import {ShopifyApi} from "./api";
import {formatMoney} from '@shopify/theme-currency';

export class BundleGrid extends Emitter {
    constructor(container) {
        super();
        this.productQty = 0;
        this.api = new ShopifyApi();
        this.container = container;
        this.cartBundle = [];
        const rcContainer = jQuery('.v4-recharge-bundle');
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.getDiscount = this.getDiscount.bind(this);
        this.calculateBundleDiscount = this.calculateBundleDiscount.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.loadedCartBundle = this.loadedCartBundle.bind(this);
        // this.clearQtyInputs = this.clearQtyInputs.bind(this);
        this.rcControl = new rechargeControl(rcContainer, this.api, container)
            .on('loadedcartbundle', this.loadedCartBundle);
        this.tagQty = {};
        const containers = container.find('.v4-quantity-selector'), selectors = [];
        for (let i = 0; i < containers.length; ++i) {
            const qs = new BundleQuantitySelector(jQuery(containers[i]), this.size);
            qs.on('change', this.handleQuantityChange);
            selectors.push(qs);
        }
        // this.clearQtyInputs();
        rcContainer.find('.add-to-cart').on('click', this.addToCart);
        this.quantitySelectors = selectors;
    }

    loadedCartBundle(data) {
        const cartBundle = data.target.cartBundle;
        this.cartBundle = cartBundle;
        this.handleQuantityChange();
        const atcButton = $('.v4-recharge-bundle .add-to-cart');
        atcButton.text('Update Cart');
    }

    handleQuantityChange(e, newValue) {
        this.productQty = 0;
        let tagQty = {},
            bundlePrice = 0,
            bundleDiscountedPrice = 0;

        for (const selector of this.quantitySelectors) {

            const qty = parseInt(selector.selector.find('input').val()),
                handle = selector.selector.parent().parent().data('product-handle'),
                tag = selector.selector.parent().parent().data('subscription-bundle-handle'),
                price = parseFloat(selector.selector.parent().parent().data('product-price'));

            this.productQty += qty;
            bundlePrice += price * qty;

            if (qty > 0) {
                if (tagQty[tag] !== undefined)
                    tagQty[tag] += qty;
                else
                    tagQty[tag] = qty;
            }

        }

        const atcButton = $('.v4-recharge-bundle .add-to-cart');
        const caption = bundlePrice === 0 ? 'Add Products' : "Add To Cart";
        atcButton.prop('disabled', bundlePrice > 0 ? false : true);

        atcButton.text(caption);
        if (bundlePrice > 0)
            atcButton.removeClass('disabled');
        else
            atcButton.addClass('disabled');

        this.tagQty = tagQty;
        const discountedPrice = this.calculateBundleDiscount();
        this.rcControl.setDiscountedPrice(formatMoney(discountedPrice * 100, window.moneyFormat));
        this.rcControl.setPrice(formatMoney(bundlePrice, window.moneyFormat));
    }

    calculateBundleDiscount() {
        const pickedProducts = this.pickedProducts();
        let discountedPrice = 0;

        for (const index in collectionProducts) {
            const product = collectionProducts[index];
            if (pickedProducts[product.handle] !== undefined) {
                const tag = this.getTag(product.tags),
                    bundlePrice = product.price / 100,
                    discount = priceScheme2[tag] !== undefined ? priceScheme2[tag] : 0,
                    discountAmount = 1 - (discount * 0.01);

                discountedPrice += bundlePrice * discountAmount * pickedProducts[product.handle];
            }
        }

        return discountedPrice;
    }

    pickedProducts() {
        const handles = this.container.find('.v4-product-tile');
        let pickedProducts = [];

        for (const handle of handles) {
            const pickedHandle = $(handle).data('product-handle');
            const pickedQty = $(handle).find('.v4-quantity-selector input[type="number"]').val();

            if (parseFloat(pickedQty) > 0)
                pickedProducts[pickedHandle] = parseFloat(pickedQty);

        }

        return pickedProducts;

    }

    getPropertyValue(handle, qty) {
        const product = priceScheme[handle];
        if (product !== undefined) {

            if (product[qty] !== undefined) {
                const originalPrice = product['original'] * qty;
                const discountedPrice = product[qty] * qty;

                return {'original_price': originalPrice, 'discounted_price': discountedPrice};

            } else {
                const originalPrice = product['original'] * qty;
                const highestDiscount = product[Object.keys(product)[Object.keys(product).length - 2]];
                const discountedPrice = highestDiscount * qty;

                return {'original_price': originalPrice, 'discounted_price': discountedPrice};
            }

        } else {
            const productObj = priceScheme['3oz'];
            const originalPrice = productObj['original'] * qty;
            const highestDiscount = productObj[Object.keys(productObj)[Object.keys(productObj).length - 2]];
            const discountedPrice = highestDiscount * qty;

            return {'original_price': originalPrice, 'discounted_price': discountedPrice};
        }
    }

    progressBar(productsQty) {
        const size = parseFloat(this.size),
            barSize = 100 / size,
            progressBarWidth = barSize * parseFloat(productsQty).toString(),
            pbString = progressBarWidth + '%';
        $('.recharge-progess-bar-wrapper .recharge-progress-bar').width(pbString);
    }

    addToCart(e) {
        e.preventDefault();
        const pickedProducts = this.pickedProducts(),
            frequency = $('.v4-rc-frequency').val(),
            bundleClassFrequency = frequency.split(' ').join('_'),
            bundleTimeStamp = Date.now();
        let data = {items: []};
        let sellingPlanId = null;
        if (frequency === '') {
            $('.frequency-form .v4-rc-frequency').focus();
            return;
        }
        for (const index in collectionProducts) {
            const product = collectionProducts[index];
            if (pickedProducts[product.handle] !== undefined) {
                for (const sellingPlan of product.selling_plan_groups[0].selling_plans) {
                    if (sellingPlan.name === frequency)
                        sellingPlanId = sellingPlan.id;
                }
                const itemCount = Object.keys(pickedProducts).length,
                    tag = this.getTag(product.tags),
                    bundlePrice = product.price / 100,
                    discount = priceScheme2[tag] !== undefined ? priceScheme2[tag] : 0,
                    bundleName = collection.name + ' * TS' + bundleTimeStamp,
                    bundleClass = collection.handle + '_*_TS' + bundleTimeStamp;
                const singleProduct = itemCount === 1 ? true : false;
                if(singleProduct){
                    data.items.push({
                        id: product.variants[0].id,
                        quantity: pickedProducts[product.handle],
                        selling_plan: sellingPlanId
                    });
                } else {
                    data.items.push({
                        properties: {
                            "_bundle": bundleName, // collection name
                            "_bundle_discount": discount,
                            "_bundle_class": bundleClass, // collection handle
                            // "_product_price": bundlePrice,
                            "_frequency": frequency,
                            "_base_product_qty": 1,
                            "_single_product": false,
                        },
                        id: product.variants[0].id,
                        quantity: pickedProducts[product.handle],
                        selling_plan: sellingPlanId
                    });
                }
                
            }
        }

        if (this.cartBundle.length > 0) {
            const cartUpdate = {updates: {}};
            for (const lineItem of this.cartBundle) {
                cartUpdate.updates[lineItem.variant_id] = 0;
            }
            this.api.cartUpdate(cartUpdate).then(() => {
                this.api.addToCart(data).then((response) => {
                    window.location.href = window.location.origin + '/cart'
                });
            });
        } else {
            this.api.addToCart(data).then((response) => {
                window.location.href = window.location.origin + '/cart'
            });
        }
    }

    getTag(tags) {
        let subscribtionTag = false;
        for (const tag of tags) {
            if (tag.includes('subscription_bundle_'))
                subscribtionTag = tag.replace('subscription_bundle_', '');
        }
        return subscribtionTag;
    }

    getDiscount(tag, price) {
        const product = priceScheme[tag];
        const qtyGroup = this.tagQty[tag];
        if (product !== undefined) {
            if (product[qtyGroup] !== undefined) {
                let discount = parseFloat(product[qtyGroup]) / parseFloat(price) * 100;
                discount = 100 - discount;
                return discount;
            } else {
                const lowestPrice = product[Object.keys(product)[Object.keys(product).length - 1]];
                let discount = parseFloat(lowestPrice) / parseFloat(price) * 100;
                discount = 100 - discount;
                return discount;
            }
        } else {
            return 0;
        }
    }

    getRandomString() {
        const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#';
        let result = '';
        for (let i = 0; i < 20; i++) {
            result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
        }

        return result;

    }
}